import { Device } from 'modules/Device/Device'
import { Model } from 'pinia-orm'

import { Attr, Uid, BelongsTo } from 'pinia-orm/dist/decorators'

export default class DeviceHardwareHistory extends Model {
  static override entity = 'device_hardware_histories'

  // Fields
  @Uid() declare id: string

  @Attr() declare index: number
  @Attr() declare timestamp: number
  @Attr() declare faults: string
  @Attr() declare event: string
  @Attr() declare bytes: string
  @Attr() declare value: string
  @Attr() declare payload: string

  @Attr() declare device_id: string

  // Relationships
  @BelongsTo(() => Device, 'device_id') declare device: Device | null
}
